'use client'

import { Toaster as ToasterBase } from 'react-hot-toast'

export function Toaster({ noMargin }: { noMargin?: boolean }) {
  return (
    <ToasterBase
      containerClassName={`!sticky top-4! ${noMargin ? '' : 'mt-4!'}`}
      toastOptions={{
        style: {
          position: 'relative',
          background: 'transparent',
          boxShadow: 'none',
          padding: '0',
          margin: '0',
          maxWidth: 'calc(100% - 32px)',
        },
      }}
    />
  )
}
